import { c as _c } from "react/compiler-runtime";
import { clsx } from "clsx";
import type { ReactNode } from "react";
type Duration = 200 | 300 | 500;
type TailwindDurationClass = `duration-${Duration}`;
const durationClasses = {
  200: "duration-200",
  300: "duration-300",
  500: "duration-500"
} as const satisfies Record<Duration, TailwindDurationClass>;
type CollapseProps = {
  readonly children: ReactNode;
  readonly isExpanded: boolean;
  readonly duration?: Duration;
  readonly className?: string;
  readonly contentClassName?: string;
};

/**
 * Collapse component that smoothly animates height changes
 * using CSS Grid. Works with any content height without needing
 * to know the actual pixel values.
 */
export function Collapse(t0) {
  const $ = _c(14);
  const {
    children,
    isExpanded,
    duration: t1,
    className,
    contentClassName
  } = t0;
  const duration = t1 === undefined ? 300 : t1;
  const t2 = !isExpanded;
  const t3 = durationClasses[duration];
  const t4 = isExpanded ? "grid-rows-[1fr]" : "grid-rows-[0fr]";
  let t5;
  if ($[0] !== className || $[1] !== t3 || $[2] !== t4) {
    t5 = clsx("grid transition-[grid-template-rows] ease-in-out", t3, t4, "motion-reduce:transition-none", className);
    $[0] = className;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== contentClassName) {
    t6 = clsx("overflow-hidden", contentClassName);
    $[4] = contentClassName;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = !isExpanded ? true : undefined;
  let t8;
  if ($[6] !== children || $[7] !== t6 || $[8] !== t7) {
    t8 = <div className={t6} inert={t7}>{children}</div>;
    $[6] = children;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t2 || $[11] !== t5 || $[12] !== t8) {
    t9 = <div aria-hidden={t2} className={t5}>{t8}</div>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
}